import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import { sizeOf } from "../../utils/propTypes";
import css from "./IconButton.module.css";

const IconButton = React.forwardRef(
  (
    {
      variant = "text",
      size = "md",
      disabled = false,
      label,
      toggle = false,
      pressed,
      className,
      children,
      ...rest
    },
    ref,
  ) => {
    const classes = clsx(css.root, css[size], css[variant], className);

    return (
      <button
        ref={ref}
        type="button"
        className={classes}
        disabled={disabled}
        aria-label={label}
        aria-pressed={toggle ? pressed : undefined}
        {...rest}
      >
        {children}
      </button>
    );
  },
);

IconButton.displayName = "IconButton";

IconButton.propTypes = {
  variant: PropTypes.oneOf(["text", "filled", "tonal", "outlined"]),
  size: sizeOf("sm", "md", "lg"),
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  toggle: PropTypes.bool,
  pressed: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default IconButton;
